export const toolbarTheme = {
  defaultProps: {
    variant: 'secondary',
    size: 'sm',
  },
};
